import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { TokenService } from '../../_shared/services/token.service';
import { AuthenticationService } from '../../_shared/services/authentication.service';

@Injectable()
export class FrontPageGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private tokenService: TokenService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // guard to protect routes from user that has logged in
    return this.authenticationService.isAuthenticated().then(loginState => {
      console.log('authguard', 'Guard', loginState);

      if (loginState === true && this.tokenService.getToken()) {
        // user is logged in, not allowed to access login page
        this.router.navigate(['/dashboard']);
        return false;
      } else {
        // user is not logged in, so allowed to access login page
        return true;
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/guards/front-page.guard.ts